import { z } from "zod";

export const aliasProductSchema = z.object({
  name: z.string().min(3, "Ingrese un nombre válido"),
  description: z.string(),
  productId: z.string().min(3, "Seleccione un producto"),
});

export type AliasProductFormInput = z.infer<typeof aliasProductSchema>;
